function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { replaceData, noop, timeUntilStale, getAbortController } from './utils.esm.js';
import { defaultLogger } from './logger.esm.js';
import { notifyManager } from './notifyManager.esm.js';
import { createRetryer, isCancelledError, canFetch } from './retryer.esm.js';
import { Removable } from './removable.esm.js';

// CLASS
var Query = /*#__PURE__*/function (_Removable) {
  function Query(config) {
    var _this;
    _classCallCheck(this, Query);
    _this = _callSuper(this, Query);
    _this.abortSignalConsumed = false;
    _this.defaultOptions = config.defaultOptions;
    _this.setOptions(config.options);
    _this.observers = [];
    _this.cache = config.cache;
    _this.logger = config.logger || defaultLogger;
    _this.queryKey = config.queryKey;
    _this.queryHash = config.queryHash;
    _this.initialState = config.state || getDefaultState(_this.options);
    _this.state = _this.initialState;
    _this.scheduleGc();
    return _this;
  }
  _inherits(Query, _Removable);
  return _createClass(Query, [{
    key: "meta",
    get: function get() {
      return this.options.meta;
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      this.options = _objectSpread(_objectSpread({}, this.defaultOptions), options);
      this.updateCacheTime(this.options.cacheTime);
    }
  }, {
    key: "optionalRemove",
    value: function optionalRemove() {
      if (!this.observers.length && this.state.fetchStatus === 'idle') {
        this.cache.remove(this);
      }
    }
  }, {
    key: "setData",
    value: function setData(newData, options) {
      var data = replaceData(this.state.data, newData, this.options); // Set data and mark it as cached

      this.dispatch({
        data: data,
        type: 'success',
        dataUpdatedAt: options == null ? void 0 : options.updatedAt,
        manual: options == null ? void 0 : options.manual
      });
      return data;
    }
  }, {
    key: "setState",
    value: function setState(state, setStateOptions) {
      this.dispatch({
        type: 'setState',
        state: state,
        setStateOptions: setStateOptions
      });
    }
  }, {
    key: "cancel",
    value: function cancel(options) {
      var _this$retryer;
      var promise = this.promise;
      (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
      return promise ? promise.then(noop).catch(noop) : Promise.resolve();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(Query, "destroy", this, 3)([]);
      this.cancel({
        silent: true
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.destroy();
      this.setState(this.initialState);
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.observers.some(function (observer) {
        return observer.options.enabled !== false;
      });
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      return this.getObserversCount() > 0 && !this.isActive();
    }
  }, {
    key: "isStale",
    value: function isStale() {
      return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function (observer) {
        return observer.getCurrentResult().isStale;
      });
    }
  }, {
    key: "isStaleByTime",
    value: function isStaleByTime() {
      var staleTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return this.state.isInvalidated || !this.state.dataUpdatedAt || !timeUntilStale(this.state.dataUpdatedAt, staleTime);
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      var _this$retryer2;
      var observer = this.observers.find(function (x) {
        return x.shouldFetchOnWindowFocus();
      });
      if (observer) {
        observer.refetch({
          cancelRefetch: false
        });
      } // Continue fetch if currently paused

      (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
    }
  }, {
    key: "onOnline",
    value: function onOnline() {
      var _this$retryer3;
      var observer = this.observers.find(function (x) {
        return x.shouldFetchOnReconnect();
      });
      if (observer) {
        observer.refetch({
          cancelRefetch: false
        });
      } // Continue fetch if currently paused

      (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
    }
  }, {
    key: "addObserver",
    value: function addObserver(observer) {
      if (!this.observers.includes(observer)) {
        this.observers.push(observer); // Stop the query from being garbage collected

        this.clearGcTimeout();
        this.cache.notify({
          type: 'observerAdded',
          query: this,
          observer: observer
        });
      }
    }
  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      if (this.observers.includes(observer)) {
        this.observers = this.observers.filter(function (x) {
          return x !== observer;
        });
        if (!this.observers.length) {
          // If the transport layer does not support cancellation
          // we'll let the query continue so the result can be cached
          if (this.retryer) {
            if (this.abortSignalConsumed) {
              this.retryer.cancel({
                revert: true
              });
            } else {
              this.retryer.cancelRetry();
            }
          }
          this.scheduleGc();
        }
        this.cache.notify({
          type: 'observerRemoved',
          query: this,
          observer: observer
        });
      }
    }
  }, {
    key: "getObserversCount",
    value: function getObserversCount() {
      return this.observers.length;
    }
  }, {
    key: "invalidate",
    value: function invalidate() {
      if (!this.state.isInvalidated) {
        this.dispatch({
          type: 'invalidate'
        });
      }
    }
  }, {
    key: "fetch",
    value: function fetch(options, fetchOptions) {
      var _this2 = this;
      var _this$options$behavio, _context$fetchOptions;
      if (this.state.fetchStatus !== 'idle') {
        if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) {
          // Silently cancel current fetch if the user wants to cancel refetches
          this.cancel({
            silent: true
          });
        } else if (this.promise) {
          var _this$retryer4;

          // make sure that retries that were potentially cancelled due to unmounts can continue
          (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry(); // Return current promise if we are already fetching

          return this.promise;
        }
      } // Update config if passed, otherwise the config from the last execution is used

      if (options) {
        this.setOptions(options);
      } // Use the options from the first observer with a query function if no function is found.
      // This can happen when the query is hydrated or created with setQueryData.

      if (!this.options.queryFn) {
        var observer = this.observers.find(function (x) {
          return x.options.queryFn;
        });
        if (observer) {
          this.setOptions(observer.options);
        }
      }
      if (process.env.NODE_ENV !== 'production') {
        if (!Array.isArray(this.options.queryKey)) {
          this.logger.error("As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']");
        }
      }
      var abortController = getAbortController(); // Create query function context

      var queryFnContext = {
        queryKey: this.queryKey,
        pageParam: undefined,
        meta: this.meta
      }; // Adds an enumerable signal property to the object that
      // which sets abortSignalConsumed to true when the signal
      // is read.

      var addSignalProperty = function addSignalProperty(object) {
        Object.defineProperty(object, 'signal', {
          enumerable: true,
          get: function get() {
            if (abortController) {
              _this2.abortSignalConsumed = true;
              return abortController.signal;
            }
            return undefined;
          }
        });
      };
      addSignalProperty(queryFnContext); // Create fetch function

      var fetchFn = function fetchFn() {
        if (!_this2.options.queryFn) {
          return Promise.reject("Missing queryFn for queryKey '" + _this2.options.queryHash + "'");
        }
        _this2.abortSignalConsumed = false;
        return _this2.options.queryFn(queryFnContext);
      }; // Trigger behavior hook

      var context = {
        fetchOptions: fetchOptions,
        options: this.options,
        queryKey: this.queryKey,
        state: this.state,
        fetchFn: fetchFn
      };
      addSignalProperty(context);
      (_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted

      this.revertState = this.state; // Set to fetching state if not already in it

      if (this.state.fetchStatus === 'idle' || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
        var _context$fetchOptions2;
        this.dispatch({
          type: 'fetch',
          meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
        });
      }
      var onError = function onError(error) {
        // Optimistically update state if needed
        if (!(isCancelledError(error) && error.silent)) {
          _this2.dispatch({
            type: 'error',
            error: error
          });
        }
        if (!isCancelledError(error)) {
          var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;

          // Notify cache callback
          (_this$cache$config$on = (_this$cache$config = _this2.cache.config).onError) == null ? void 0 : _this$cache$config$on.call(_this$cache$config, error, _this2);
          (_this$cache$config$on2 = (_this$cache$config2 = _this2.cache.config).onSettled) == null ? void 0 : _this$cache$config$on2.call(_this$cache$config2, _this2.state.data, error, _this2);
          if (process.env.NODE_ENV !== 'production') {
            _this2.logger.error(error);
          }
        }
        if (!_this2.isFetchingOptimistic) {
          // Schedule query gc after fetching
          _this2.scheduleGc();
        }
        _this2.isFetchingOptimistic = false;
      }; // Try to fetch the data

      this.retryer = createRetryer({
        fn: context.fetchFn,
        abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
        onSuccess: function onSuccess(data) {
          var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
          if (typeof data === 'undefined') {
            if (process.env.NODE_ENV !== 'production') {
              _this2.logger.error("Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: " + _this2.queryHash);
            }
            onError(new Error(_this2.queryHash + " data is undefined"));
            return;
          }
          _this2.setData(data); // Notify cache callback

          (_this$cache$config$on3 = (_this$cache$config3 = _this2.cache.config).onSuccess) == null ? void 0 : _this$cache$config$on3.call(_this$cache$config3, data, _this2);
          (_this$cache$config$on4 = (_this$cache$config4 = _this2.cache.config).onSettled) == null ? void 0 : _this$cache$config$on4.call(_this$cache$config4, data, _this2.state.error, _this2);
          if (!_this2.isFetchingOptimistic) {
            // Schedule query gc after fetching
            _this2.scheduleGc();
          }
          _this2.isFetchingOptimistic = false;
        },
        onError: onError,
        onFail: function onFail(failureCount, error) {
          _this2.dispatch({
            type: 'failed',
            failureCount: failureCount,
            error: error
          });
        },
        onPause: function onPause() {
          _this2.dispatch({
            type: 'pause'
          });
        },
        onContinue: function onContinue() {
          _this2.dispatch({
            type: 'continue'
          });
        },
        retry: context.options.retry,
        retryDelay: context.options.retryDelay,
        networkMode: context.options.networkMode
      });
      this.promise = this.retryer.promise;
      return this.promise;
    }
  }, {
    key: "dispatch",
    value: function dispatch(action) {
      var _this3 = this;
      var reducer = function reducer(state) {
        var _action$meta, _action$dataUpdatedAt;
        switch (action.type) {
          case 'failed':
            return _objectSpread(_objectSpread({}, state), {}, {
              fetchFailureCount: action.failureCount,
              fetchFailureReason: action.error
            });
          case 'pause':
            return _objectSpread(_objectSpread({}, state), {}, {
              fetchStatus: 'paused'
            });
          case 'continue':
            return _objectSpread(_objectSpread({}, state), {}, {
              fetchStatus: 'fetching'
            });
          case 'fetch':
            return _objectSpread(_objectSpread({}, state), {}, {
              fetchFailureCount: 0,
              fetchFailureReason: null,
              fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
              fetchStatus: canFetch(_this3.options.networkMode) ? 'fetching' : 'paused'
            }, !state.dataUpdatedAt && {
              error: null,
              status: 'loading'
            });
          case 'success':
            return _objectSpread(_objectSpread({}, state), {}, {
              data: action.data,
              dataUpdateCount: state.dataUpdateCount + 1,
              dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
              error: null,
              isInvalidated: false,
              status: 'success'
            }, !action.manual && {
              fetchStatus: 'idle',
              fetchFailureCount: 0,
              fetchFailureReason: null
            });
          case 'error':
            var error = action.error;
            if (isCancelledError(error) && error.revert && _this3.revertState) {
              return _objectSpread(_objectSpread({}, _this3.revertState), {}, {
                fetchStatus: 'idle'
              });
            }
            return _objectSpread(_objectSpread({}, state), {}, {
              error: error,
              errorUpdateCount: state.errorUpdateCount + 1,
              errorUpdatedAt: Date.now(),
              fetchFailureCount: state.fetchFailureCount + 1,
              fetchFailureReason: error,
              fetchStatus: 'idle',
              status: 'error'
            });
          case 'invalidate':
            return _objectSpread(_objectSpread({}, state), {}, {
              isInvalidated: true
            });
          case 'setState':
            return _objectSpread(_objectSpread({}, state), action.state);
        }
      };
      this.state = reducer(this.state);
      notifyManager.batch(function () {
        _this3.observers.forEach(function (observer) {
          observer.onQueryUpdate(action);
        });
        _this3.cache.notify({
          query: _this3,
          type: 'updated',
          action: action
        });
      });
    }
  }]);
}(Removable);
function getDefaultState(options) {
  var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
  var hasData = typeof data !== 'undefined';
  var initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
  return {
    data: data,
    dataUpdateCount: 0,
    dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: false,
    status: hasData ? 'success' : 'loading',
    fetchStatus: 'idle'
  };
}
export { Query };